import React from 'react';
import {CompositeDecorator} from 'draft-js';
import type {ContentBlock, ContentState} from 'draft-js';

function mentionStrategy(
	contentBlock: ContentBlock,
	callback: (start: number, end: number) => void,
	contentState: ContentState
) {
	contentBlock.findEntityRanges(char => {
		const entityKey = char.getEntity();
		if (!entityKey) return false;
		return contentState.getEntity(entityKey).getType() === 'MENTION';
	}, callback);
}

function MentionDecoratorSpan(props: {children: React.ReactNode}) {
	return React.createElement(
		'span',
		{
			className:
				'mx-0.5 inline-flex items-center rounded-full bg-blue-50 px-1.5 py-0.5 text-xs font-medium text-blue-700',
		},
		props.children
	);
}

export const mentionDecorator = new CompositeDecorator([
	{
		strategy: mentionStrategy,
		component: MentionDecoratorSpan,
	},
]);
